export enum AdditionalReportingCategories {
  TD_WITHOUT_PD = "TD without PD",
  PD_WITHOUT_WEIGHT = "PD without Weight",
  OUT_OF_SCOPE = "Out of Scope"
}
